/* FANNUR v0.5 | vaste tekstcomposities: geen vrije posities, beschermde layouts */
(function () {
  'use strict';
  const textFit = (ctx, text, maxWidth, startSize, minSize, family, weight='normal') => {
    let size = startSize;
    do { ctx.font = `${weight} ${size}px "${family}"`; if(ctx.measureText(text).width <= maxWidth) break; size -= 2; } while (size>minSize);
    return size;
  };
  function wrap(ctx, value, width, maxLines) {
    const words=String(value||'').split(/\s+/).filter(Boolean), lines=[];
    let line='';
    for(const word of words){
      const proposed=line?line+' '+word:word;
      if(line && ctx.measureText(proposed).width>width){lines.push(line);line=word;}else line=proposed;
    }
    if(line)lines.push(line);
    return lines.slice(0,maxLines);
  }
  function centered(ctx, value, x, y, width, size, family, options={}) {
    const min=options.min||20, linesMax=options.lines||2;
    const valueText=String(value||'');
    ctx.fillStyle=options.ink||'#222';ctx.textAlign='center';ctx.textBaseline='middle';
    let sz=size, lines=[];
    while(sz>=min){
      ctx.font=`${options.weight||'normal'} ${sz}px "${family}"`;
      lines=wrap(ctx,valueText,width,linesMax);
      const last=lines.join(' ');
      if(last.length>=valueText.trim().length || sz===min)break;
      sz-=2;
    }
    const gap=sz*1.16;
    lines.forEach((line,i)=>ctx.fillText(line,x,y+(i-(lines.length-1)/2)*gap,width));
  }
  function draw(ctx, t, state, W, H) {
    const x=W/2, f=role=>state.fontFamilies?.[role]||'Georgia', ink=state.ink, value=id=>state.values[id]||'';
    ctx.fillStyle=state.bg;ctx.fillRect(0,0,W,H);
    if(t.layout==='jersey'){
      const img=state.backgroundImg;
      if(!img || !img.naturalWidth || !img.naturalHeight)return;
      // Behält de volledige afbeelding; geen verborgen crop aan de randen.
      const fit=Math.min(W/img.naturalWidth,H/img.naturalHeight);
      const drawW=img.naturalWidth*fit,drawH=img.naturalHeight*fit;
      ctx.drawImage(img,(W-drawW)/2,(H-drawH)/2,drawW,drawH);
      const options=state.jerseyLayout||{};
      const place=(id,text,defaultY,defaultSize,defaultWidth)=>{
        const family=f(id).replace(/["\\]/g,''),y=H*(options[id+'Y']??defaultY);
        const maxW=W*(options[id+'Width']??defaultWidth);
        let size=W*(options[id+'Size']??defaultSize);
        const weight=state.fontWeights?.[id]||'bold';
        ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillStyle=ink;
        for(;size>W*.025;size-=2){
          ctx.font=weight+' '+size+'px "'+family+'"';
          if(ctx.measureText(text).width<=maxW)break;
        }
        ctx.fillText(text,W*(options[id+'X']??.5),y,maxW);
      };
      place('name',String(value('name')).toUpperCase(),.255,.105,.70);
      place('number',String(value('number')).replace(/\D/g,'').slice(0,2),.515,.47,.59);
      return;
    }
    if(t.layout==='date'){
      const centers=[.25,.455,.665];
      ['day','month','year'].forEach((id,i)=>{
        const val=value(id), size=textFit(ctx,val,W*.7,W*.22,40,f('heading'));
        ctx.fillStyle=ink;ctx.textAlign='center';ctx.textBaseline='middle';ctx.font=`${size}px "${f('heading')}"`;
        ctx.fillText(val,x,H*centers[i]);
        if(i<2){ctx.fillStyle=ink;ctx.globalAlpha=.46;ctx.fillRect(W*.30,H*(centers[i]+.103),W*.40,1.2);ctx.globalAlpha=1;}
      });
      centered(ctx,value('coordinates'),x,H*.852,W*.82,W*.026,f('detail'),{ink,min:14,lines:1});
      centered(ctx,value('names'),x,H*.895,W*.74,W*.021,f('detail'),{ink,min:12,lines:2});
    } else if(t.layout==='wedding'){
      centered(ctx,value('heading'),x,H*.40,W*.84,W*.139,f('heading'),{ink,min:32,lines:2});
      centered(ctx,value('names'),x,H*.525,W*.81,W*.074,f('script'),{ink,min:23,lines:2});
      centered(ctx,value('date'),x,H*.845,W*.8,W*.024,f('detail'),{ink,min:16,lines:2});
      centered(ctx,value('coordinates'),x,H*.88,W*.8,W*.017,f('detail'),{ink,min:11,lines:1});
    } else {
      centered(ctx,value('title'),x,H*.47,W*.78,W*.093,f('heading'),{ink,min:28,lines:3});
      centered(ctx,value('subtitle'),x,H*.65,W*.78,W*.042,f('detail'),{ink,min:18,lines:3});
      ctx.fillStyle=ink;ctx.globalAlpha=.25;ctx.fillRect(W*.42,H*.585,W*.16,1.6);ctx.globalAlpha=1;
    }
  }
  window.FANNUR_MODULES_V05=window.FANNUR_MODULES_V05||{};
  window.FANNUR_MODULES_V05['text-only']={draw};
})();
